
seedWebServices.service('DicService', ['$http', '$cacheFactory', '$uibModal', 'TranslationService', function ($http, $cacheFactory, $uibModal, TranslationService) {

    var serviceCache = $cacheFactory('DicService');

    var URL = '../Api/Dic/';

    this.resetCache = function () {
        serviceCache.removeAll();
    };

    this.getList = function (stringFilter) {
        var cache = serviceCache;
        return $http.get(URL, {
            params: { stringFilter: 'stringFilter' },
            cache: cache
        });
    };

    this.getDic = function (id) {
        var cache = serviceCache;
        return $http.get(URL + 'GetDic', {
            params: { id: id },
            cache: cache
        });
    };

    this.getDicsCount = function () {
        return $http.get(URL + 'GetDicsCount', {
            params: {},
            cache: serviceCache
        });
    };

    this.getDics = function (filterString, options, skipNumber, takeNumber, sort) {
        return $http.put(URL + '/SearchDics', { filterString: filterString, options: options, skipNumber: skipNumber, takeNumber: takeNumber, sort: sort }, { cache: serviceCache });
    };

    this.getDicsColumns = function (column, filterString, skipSize, takeSize) {
        return $http.get(URL + '/GetDicsColumns', {
            params: { column: column, filterString: filterString, skipSize: skipSize, takeSize: takeSize },
            cache: serviceCache
        });
    };

    this.openDicModal = function (dicID) {
        $uibModal.open({
            templateUrl: './SPA/dics/dicModal.html',
            controller: 'DicModalCtrl',
            size: 'lg',
            resolve: {
                dicID: function () {
                    return dicID;
                }
            }
        });
    };

    this.saveDic = function (material) {
        return $http.post(URL + '/SaveDic', material, true);
    };

    this.rebuildAll = function () {
        return $http.get(URL + '/RebuildAll', {
            params: {},
            cache: false
        });
    };

    this.rebuildDic = function (dicID) {
        return $http.get(URL + '/RebuildDic', {
            params: { dicID: dicID },
            cache: false
        });
    };


    this.getColsCount = function () {
        return $http.get(URL + 'GetColsCount', {
            params: {},
            cache: serviceCache
        });
    };

    this.getCols = function (filterString, options, skipNumber, takeNumber, sort) {
        return $http.put(URL + '/SearchCols', { filterString: filterString, options: options, skipNumber: skipNumber, takeNumber: takeNumber, sort: sort }, { cache: serviceCache });
    };

    this.getColsColumns = function (column, filterString, skipSize, takeSize) {
        return $http.get(URL + '/GetColsColumns', {
            params: { column: column, filterString: filterString, skipSize: skipSize, takeSize: takeSize },
            cache: serviceCache
        });
    };

    this.getIntegrationsCount = function () {
        return $http.get(URL + 'GetIntegrationsCount', {
            params: {},
            cache: serviceCache
        });
    };

    this.searchIntegrations = function (filterString, options, skipNumber, takeNumber, sort) {
        return $http.put(URL + '/SearchIntegrations', { filterString: filterString, options: options, skipNumber: skipNumber, takeNumber: takeNumber, sort: sort }, { cache: serviceCache });
    };



}]);